import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import type { FieldMode } from '../contracts/field.binding';
import type { SectionFieldDeclaration } from '../sections/wb.section.component';

/**
 * Capability controls beside a host's close button. Mounts each renderer bare — no label row — with
 * the same `field` / `metadata` / `surfaceMode` contract `wb-field` gives a custom renderer.
 */
@Component({
  selector: 'wb-surface-capability-region',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [NgComponentOutlet],
  template: `
    @for (item of $items(); track item.key) {
      <ng-container [ngComponentOutlet]="item.component" [ngComponentOutletInputs]="item.$inputs()" />
    }
  `,
  // Contents: controls join the host's header-action row and take its gap and alignment.
  host: { style: 'display: contents' },
})
export class WbSurfaceCapabilityRegionComponent {

  public readonly $fields = input.required<readonly SectionFieldDeclaration[]>({ alias: 'fields' });
  public readonly $surfaceMode = input<FieldMode>('edit', { alias: 'surfaceMode' });

  protected readonly $items = computed(() => this.$fields().map(declaration => ({
    key: declaration.field.bind,
    component: declaration.customRenderer!,
    $inputs: computed(() => ({
      ...declaration.customRendererInputs?.(),
      field: declaration.field,
      metadata: declaration.metadata,
      surfaceMode: declaration.field.$readonly() ? 'read' : this.$surfaceMode(),
    })),
  })));
}
